import React, { PureComponent } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 1);
	display: table;
	text-align: center;
`
const TextContainer = styled.div`
	display: table-cell;
	font-size: 20px;
	padding: 0 5%;
	vertical-align: middle;
`

class NotSupported extends PureComponent {
	render() {
		return (
			<Wrapper>
				<TextContainer>
					Time to Climb is not available in student-paced mode. Please advance to the next slide.
				</TextContainer>
			</Wrapper>
		)
	}
}

export default NotSupported
